require('./alert.less');

var Backbone = require('backbone'),
    Marionette = require('marionette'),
    $ = require('jquery');

require('jqIframeShim');


module.exports = Marionette.ItemView.extend({

    className: 'FV-alert',
    template: require('./alert.hbs'),

    typeShortXRef: {
        error: { icon: 'icon-attention-circled' },
        success: { icon: 'icon-ok-circled-1' },
        info: { icon: '' }
    },

    // Explicitly define options with defaults for clarity.

    initialize: function( options ) {

        // Here are the default options to pass in
        var settings = {
            type: 'error',
            shortMessage: 'Alert',
            detailedMsg: '',
            allowClose: true,
            closeTimeout: null,
            detailedMsgPreserveLineBreaks: false // ( if set to true you can break lines with '\n'
        };

        // Allow to close by default.
        // If closeTimeout is provided, disallow allowClose, unless it is explicitly provided.

        if (options) {

            $.extend( settings, options );

            if ( options.closeTimeout && !options.allowClose) {
                settings.allowClose = false;
            }

        }

        this.settings = settings;

    },

    /*
    * Note: short message required.
    * Detail, timeout is optional.
    * */
    serializeData: function() {

        return {
            hideCloseButton: !this.settings.allowClose,
            shortMsg: this.settings.shortMessage,
            longMessage: this.settings.detailedMsg,
            typeClass: this.settings.type === 'info'
                ? ''
                : 'alert-' + this.settings.type,
            iconClass: this.typeShortXRef[this.settings.type].icon,
            detailedMsgPreserveLineBreaks: this.settings.detailedMsgPreserveLineBreaks
        };

    },
    onShow: function() {

        var actualWidth = this.$el.css({ width: 'auto' }).outerWidth(),
            self = this,
            closeTimeout = this.settings.closeTimeout;

        this.$el.css({ 'margin-left': -1 * actualWidth / 2 }); // do now on region and make responsive ?
        this.$el.iframeShim();
       
        if (closeTimeout)

            setTimeout( function() {
                self.destroy();
                clearTimeout(closeTimeout);
            }, closeTimeout) ;

    },
    ui: {
        closeBtn: '.close'
    },
    events: {
        'click @ui.closeBtn': function(e) {
            e.stopPropagation();
            this.destroy();
        }
    },
    onRender: Backbone.View.prototype.unwrap,

    /**
     * Fade out the view and allow for destroy of shim -- need method, not onBefore for fadeout.
     */
    destroy: function() {

        var $el = this.$el,
            self = this,
            args = _.toArray(arguments);

        $el.fadeOut(200, function() {
            $el.iframeShim('destroy');
            Marionette.ItemView.prototype.destroy.apply(self, args);
        });
    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/alert/alert.js
 ** module id = 688
 ** module chunks = 0
 **/